import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, signal, SimpleChanges } from '@angular/core';

@Component({
  selector: 'cash-payment',
  imports: [CommonModule],
  templateUrl: `./cash-payment.component.html`,
  styleUrl: './cash-payment.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CashPaymentComponent implements OnChanges {

  @Input() withCash: boolean = false;
  isPayWithCashSignal = signal(false);



  ngOnChanges(changes: SimpleChanges): void {
    if (changes['withCash']) {
      this.isPayWithCashSignal.set(this.withCash);
    }
  }

}
